import { api } from '@/shared/lib/api'
import { SearchParams } from '@workspace/lib/api'
import { useQuery } from '@tanstack/react-query'

export const useGlobalSearch = (params: SearchParams, enabled: boolean = true) => {
    return useQuery({
        queryKey: ['global-search', params],
        queryFn: () => api.searchGlobal.search(params),
        enabled: enabled && !!params.q,
    })
}
